// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Py_sqE-3qU0QdE9I1FNyX","title":"uVNhRgu3jD478zHli0iy"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/Pending/styles.css
// module id = 3166
// module chunks = 0